import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

// Mobile-only sticky bottom CTA. Appears after the user scrolls past
// the hero so it doesn't fight with the hero's primary buttons.
// Links directly to the sales funnel offer page.
const TARGET_URL = "/offer";

export default function StickyQuoteBadge() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={TARGET_URL}
      data-testid="sticky-quote-badge"
      aria-label="Book now. see our ceramic coating pricing"
      className={`
        md:hidden fixed left-4 right-4 z-40
        flex items-center justify-between gap-3
        h-14 px-5 rounded-full
        bg-acid text-[#120127] font-label tracking-[0.2em] text-sm uppercase
        shadow-[0_10px_40px_rgba(168,224,0,0.45)]
        transition-all duration-500 ease-out
        ${visible
          ? "bottom-4 opacity-100 translate-y-0"
          : "-bottom-20 opacity-0 translate-y-4 pointer-events-none"
        }
      `}
    >
      <span className="flex-1 text-center">Book Now</span>
      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#120127] text-acid">
        <ArrowRight className="w-4 h-4" />
      </span>
    </a>
  );
}
